export default class OrderPricesCalculator {
  constructor() {
    if (this.vars()) {
      this.setupEvents();
      this.update(true);
    }
  }

  vars() {
    this.form = document.getElementById('dashboardMakeOrder');

    if (!this.form) return;

    this.selectables = document.querySelectorAll('.order-row .selectric');
    this.paymentMethodsInputs = this.form.querySelectorAll('.paymentMethods__input');

    if (!this.selectables.length || !this.paymentMethodsInputs.length) return;

    this.rows = this.form.querySelectorAll('.order-row');
    this.summaryText = this.form.querySelector('.summary-value');
    this.button = document.getElementById('payButton');
    this.total = 0;

    this.noBankError = document.getElementById('noPaymentMethodError');
    this.noAdsError = document.getElementById('noSelectionError');

    return true;
  }

  setupEvents() {
    $(this.selectables).on('change', () => this.update());
    $(this.paymentMethodsInputs).on('change', () => this.update());
  }

  update(firstLoad = false) {
    this.total = 0;
    const checkedPaymentMethod = this.form.querySelector('.paymentMethods__input:checked');
    let isOk = false;

    Array.from(this.rows).forEach((row, index) => {
      const item = row.querySelector('.selectric-items .selected');

      if (item) {
        const itemIndex = item.getAttribute('data-index');
        const options = row.querySelectorAll('.selectric-hide-select option');
        const option = options[itemIndex];
        const price = option.getAttribute('data-price');
        const valEl = row.querySelector('.price-value');

        this.total += parseFloat(price);
        valEl.innerText = price;
        this.summaryText.innerText = this.total.toFixed(2);
        this.noAdsError.style.display = 'none';
        this.noBankError.style.display = 'none';

        if (this.total > 0 && checkedPaymentMethod) {
          // this.button.disabled = false;
          isOk = true;
        } else {
          if (!firstLoad) {
            if (this.total === 0) {
              this.noAdsError.style.display = 'block';
            }
            if (!checkedPaymentMethod) {
               this.noBankError.style.display = 'block';
            }
          }
          // this.button.disabled = true;
        }
      }
    });

    return isOk;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/Forms/OrderPricesCalculator.js